import React, { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";


import { Box } from "react-feather";
import ButtonComponent from "../../components/saving-league/buttonBottom";
import { useNavigate } from "react-router-dom";
const shopfeaturedbg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/feature-brand.png";
const shopfeaturedimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/podium 1.png";
const amazonLogo = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon.png";
export default function ShopFromBrand() {
  // const [data,setData] = useState(null)
  const segment = localStorage.getItem('segment')
  const navigate = useNavigate()

  const [link,setLink] = useState('')

  const [data,setData] = useState({})

  const fetchBrand = async() =>{
    try {
      let response = await fetch('https://leaderboard-1.earningshub.co/api/user/get_featurebrand')
      let data = await response.json()
      setData(data?.data[0])
      setLink(segment == 1 ? data?.data[0]?.link_active : segment == 2 ? data?.data[0]?.link_lapsed : segment == 4 ? data?.data[0]?.link_active : data?.data[0]?.link_inactive_new)
    } catch (error) {
      console.log(error)
      navigate('/savings-league/index',{replace:true})
    }
  }

  useEffect(()=>{
    fetchBrand()
  },[])


  return (
    <>
    <Grid container sx={{ background: "#fff", minHeight:"100%"  }}>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Grid
          sx={{
            background: '#1F162E',
          width: "100%",
           height:"100%"
          }}
        >
          <Grid pb={2}>
          <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/brand_banner.png" alt="Top Banner" style={{ width: "100%", }} />

          </Grid>
          <Grid item sx={12} pr={3} pl={3} pb={2} mt={2}>
                      <Typography
                        sx={{
                          color: "#FFF",
                          textAlign: "center",
                          fontFamily: "Metropolis",
                          fontSize: "16px",
                          border: "0",
                          fontStyle: "normal",
                          fontWeight: 700,
                          lineHeight: "140%",
                          textTransform: "capitalize",
                          marginBottom: "8px",
                        }}
                      >
Shop from today's featured brand
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontFamily: "Metropolis",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 500,
                          lineHeight: "140%",
                          color: "#fff",
                        }}
                      >
                        Don't miss out! Shop from our brand of the day and get 300 points
                      </Typography>
                    </Grid>

          <Grid sx={12} >
            <Grid
              sx={{
                position: "relative",
                top: "-100px",
                marginBottom: "-140px",
                display:'flex',
                // justifyContent:'center',
                // alignItems:'center'
              }}
            >
              <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/bg_brand.png" style={{ width: "100%" }} />
              <img
                src={data?.logo_url}
                style={{
                  position: "absolute",
                  top: "45%",
                  left: "0",
                  right: "0",
                  margin: "0 auto",
                  width:'30%',
                  // maxWidth: "150px",
                  // maxHeight:'150px',
                  objectFit:'contain'
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            pb={12}
            pl={4.75}
            pr={4.75}
            style={{ justifyContent: "center" }}
          >
            <Grid sx={12}>
              <Typography
                sx={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "140%",
                  minHeight:"140px"
                }}
              >
                Note: On the same day if you shop more
                <br /> than once on a particular brand, you get points only once
                
              </Typography>
            </Grid>
          </Grid>
          <a href={link}><ButtonComponent title ={`Shop From ${data?.brand_name}`}/></a>

        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
    </Grid>
    <style>
            {
                `
                body{background: #1f162e;}
                
                `
            }
        </style>
    </>
    
  );
}
